module.exports = __webpack_public_path__ + "static/Illustration-31ea5f907d7f9fe342b53ec094f9cce4.png";